module.exports = __webpack_public_path__ + "static/media/6.88644265.jpg";